import React from 'react';
import PropTypes from 'prop-types';

import CheckmarkIcon from 'images/ask/icons/check.svg';

const ConditionBox = ({ name }) => (
  <div className="condition-box">
    <img src={CheckmarkIcon} />
    <span>{name}</span>
  </div>
);

ConditionBox.propTypes = {
  name: PropTypes.string.isRequired
};

export default ConditionBox;
